<template>
    <AModal
        :visible="visible"
        title="List Distributor"
        @cancel="handleModalCancel"
        :destroy-on-close="true"
        width="70%"
        :footer="null">

        <template v-if="hasRoles([ROLE_ADMIN_BK, ROLE_DISTRIBUTOR, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_ASM])">
            <AForm
                v-if="state.isForm"
                ref="formRef"
                class="myform"
                :model="form"
                :rules="state.rules"
                @finish="handleOk"
                :wrapper-col="{ span: 14 }"
                :scroll-to-first-error="true">
                <a-row class="form-row">
                    <a-col :sm="24">
                        <a-form-item
                            label="Pilih Distributor"
                            label-align="left"
                            :label-col="{ sm: { span: 4 } }"
                            :wrapper-col="{ sm: { span: 24 - 4 } }"
                            required
                            name="vendor_id"
                            has-feedback>
                            <FilterDistributor
                                v-model:value="form.vendor_id"
                                :mode="null"
                                style="width:100%;"/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row class="form-row mt-2">
                    <ACol :sm="4"/>
                    <a-col :sm="20">
                        <ASpace>
                            <AButton
                                type="primary"
                                html-type="submit"
                                :loading="form.busy"
                                :disabled="form.busy">Simpan</AButton>
                            <AButton
                                title="Batal"
                                @click="state.isForm = !state.isForm; form.reset()">Batal</AButton>
                        </ASpace>
                    </a-col>
                </a-row>
            </AForm>
            <div
                v-else
                class="row justify-content-end">
                <div class="col-auto">
                    <ASpace>
                        <ATooltip
                            v-if="hasRoles([ROLE_ADMIN_BK, ROLE_DISTRIBUTOR, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_ASM])"
                            title="Tambahkan">
                            <AButton
                                :disabled="!item.active"
                                @click="state.isForm = !state.isForm"
                                type="primary">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </AButton>
                        </ATooltip>
                    </ASpace>
                </div>
            </div>
       </template>
        
        <AAlert
            v-if="errorMessage"
            type="error"
            :message="errorMessage"
            banner
            closable
            @close="errorMessage = null"/>

        <div v-if="state.errors.length" class="mt-2">
            <AAlert
                v-for="(item, index) in state.errors"
                class="mb-2"
                type="error"
                :key="index"
                :message="item.message"
                banner
                closable
                @close="state.errors = []" />
        </div>

        <!-- list table -->
        <div class="table-responsive text-nowrap mt-4">
            <MdTable
                :columns="state.columns"
                :data-source="state.data"
                size="small"
                :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                :pagination="{
                    showSizeChanger: true,
                    pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
                    showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
                    total: state.meta.total,
                    pageSize: state.meta.per_page,
                    current: state.meta.page,
                }"
                @change="handleTableChange"
                :loading="state.isFetching">
                <template #action="{ record }">
                    <ASpace>
                        <ATooltip
                            v-if="hasRoles([ROLE_ADMIN_BK, ROLE_DISTRIBUTOR, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_ASM])"
                            title="Hapus">
                            <AButton
                                class="button"
                                size="small"
                                :disabled="record.isDeleteDisabled"
                                :loading="record.isDelete"
                                @click="btnDelete(record)">
                                <i class="fe fe-trash" />
                            </AButton>
                        </ATooltip>
                    </ASpace>
                </template>
            </MdTable>
        </div>
    </AModal>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import FilterDistributor from '@/components/filter/FilterDistributor'
import Form from 'vform'
import { pickBy, includes } from 'lodash'
import {
    hasRoles,
    ROLE_ADMIN_BK,
    ROLE_TSO,
    ROLE_ASM,
    ROLE_TIM_CRM,
    ROLE_DISTRIBUTOR,
    ROLE_HELPDESK,
} from '@/helpers'

export default defineComponent({
    components: {
        FilterDistributor,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
            }),
        },
    },
    emits: ['update:visible'],
    setup(props, { emit }) {
        const errorMessage = ref()
        const formRef = ref();

        const form = reactive(new Form({
            vendor_id: [],
        }))

        const state = reactive({
            columns: [
                {
                    title: 'Kode Distributor',
                    dataIndex: 'distributor_code',
                },
                {
                    title: 'Nama Distributor',
                    dataIndex: 'distributor_name',
                },
                {
                    title: 'Total Toko Termapping',
                    dataIndex: 'total_toko',
                },
                {
                    title: 'Action',
                    dataIndex: 'action',
                    slots: { customRender: 'action' },
                },
            ],
            endpoint: `/api/users-salesman/distributors/${props.item.id}`,
            errors: [],
            data: [],
            meta: {
                per_page: 10,
                page: 1,
                total: 0,
            },
            isFetching: false,
            params: {
                q: '',
                page: 1,
                "per-page": 10,
            },
            isForm: false,
            rules: {
                vendor_id: [
                    {
                        required: true,
                        message: "Distributor tidak boleh kosong!",
                    },
                ],
            },
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const handleTableChange = (page, filters, sorter) => {
            state.params.page = page.current
            state.params["per-page"] = page.pageSize

            fetchDataList()
        }

        const handleOk = async () => {
            // validation form
            await formRef.value.validate()
                .catch(() => { });

            form.post(state.endpoint)
                .then(({ data }) => {
                    if (data === undefined) {
                        errorMessage.value = `Kode error 500, No response from server`
                        return
                    }

                    state.errors = data.filter(item => !item.success)

                    data.forEach(item => {
                        if (item.success && state.isForm) {
                            form.reset()
                            formRef.value.resetFields()
                            state.isForm = false
                            fetchDataList()
                        }
                        if (item.success) {
                            message.success(item.message)
                        }
                    })
                })
                .catch(async error => {
                    errorMessage.value = null
                    if (error.response) {
                        const { status, statusText } = error.response
                        const message = error.response.data.msg
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }
                })

        }

        // fetch list data
        const fetchDataList = () => {
            state.isFetching = true

            apiClient
                .get(state.endpoint, {
                    params: pickBy(state.params),
                })
                .then(({ data }) => {
                    const { items, _meta } = data

                    items.forEach((item) => {
                        item.isDelete = false
                        // disable delete button if total toko > 0
                        item.isDeleteDisabled = !props.item.is_empty_toko
                    })

                    state.data = items
                    state.meta.page = _meta.currentPage
                    state.meta.per_page = _meta.perPage
                    state.meta.total = _meta.totalCount
                })
                .finally(() => {
                    state.isFetching = false
                })
        }

        // btn delete
        const btnDelete = (record) => {
            Modal.confirm({
                title: 'Konfirmasi Hapus',
                content: 'Apakah anda ingin hapus item tersebut?',
                onOk() {
                    record.isDelete = true

                    apiClient
                        .post(`/api/users-salesman/distributors/${props.item.id}/delete`, {
                            id: record.id,
                        })
                        .then(({ data }) => {
                            fetchDataList()
                            message.success(data.message)
                        })
                        .catch(e => message.error('Gagal menghapus!'))
                        .finally(() => {
                            record.isDelete = false
                        })
                },
                onCancel() { },
            })
        }

        onMounted(() => {
            fetchDataList()
            
            // only action column
            if (!hasRoles([ROLE_ADMIN_BK, ROLE_DISTRIBUTOR, ROLE_TSO, ROLE_TIM_CRM, ROLE_HELPDESK, ROLE_ASM])) {
                state.columns = state.columns.filter(item => {
                    if (!includes(['action'], item.dataIndex)) {
                        return item
                    }
                })
            }
        })

        return {
            fetchDataList,
            state,
            formRef,
            form,
            errorMessage,
            handleModalCancel,
            handleTableChange,
            handleOk,
            btnDelete,
            // only variable role
            hasRoles,
            ROLE_ADMIN_BK,
            ROLE_TSO,
            ROLE_ASM,
            ROLE_TIM_CRM,
            ROLE_DISTRIBUTOR,
            ROLE_HELPDESK,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
